import React from "react";
import PropTypes from "prop-types";
import { BooleanInput } from "react-admin";

/**
 * A boolean input component that inverts the boolean value for activated/deactivated status
 * @param {string} source - The source field name
 * @param {string} label - The label for the input
 * @param {object} props - Additional props to pass to BooleanInput
 */
const ActivatedBooleanInput = ({ source, label, ...props }) => {
  return (
    <BooleanInput
      {...props}
      source={source}
      label={label}
      parse={value => !value}
      format={value => !value}
    />
  );
};

ActivatedBooleanInput.propTypes = {
  source: PropTypes.string.isRequired,
  label: PropTypes.string,
};

ActivatedBooleanInput.defaultProps = {
  label: "",
};

export default ActivatedBooleanInput;
